import React from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowUp } from "react-icons/fa";

const LINKS = [
  { label: "About", to: "/About-me" },
  { label: "Journey", to: "/Education" },
  { label: "Work", to: "/MyProjects" },
  { label: "Contact", to: "/contact" },
];

function GoodBye() {
  const navigate = useNavigate();

  return (
    <footer className="relative bg-dark-bg px-4 pb-10 sm:px-6">
      <div className="mx-auto max-w-6xl 2xl:max-w-7xl">
        <div className="h-px w-full bg-slate-800" />

        <div className="grid gap-6 pt-10 lg:grid-cols-[auto_1fr_auto] lg:items-center">
          <button
            onClick={() => navigate("/")}
            className="flex items-center gap-2.5"
          >
            <span className="grid h-9 w-9 shrink-0 place-items-center rounded-xl border border-primary-500/30 bg-primary-500/10 text-sm font-bold text-primary-400 font-display">
              MH
            </span>
            <span className="text-sm font-semibold text-slate-200 font-display">
              Mirza Herenda
            </span>
          </button>

          <ul className="flex flex-wrap gap-x-7 gap-y-2 text-sm lg:justify-center">
            {LINKS.map((l) => (
              <li key={l.to}>
                <button
                  onClick={() => navigate(l.to)}
                  className="text-slate-400 transition-colors duration-300 hover:text-primary-400"
                >
                  {l.label}
                </button>
              </li>
            ))}
          </ul>

          <button
            onClick={() => navigate("/")}
            className="group inline-flex w-fit items-center gap-2 rounded-xl border border-slate-800 bg-slate-900/50 px-4 py-2.5 text-sm font-semibold text-slate-200 transition-all duration-300 hover:-translate-y-0.5 hover:border-primary-500/45 hover:text-primary-400"
          >
            Back to top
            <FaArrowUp className="text-xs transition-transform duration-300 group-hover:-translate-y-0.5" />
          </button>
        </div>

        <p className="mt-10 text-xs text-slate-500">
          &copy; {new Date().getFullYear()} Mirza Herenda. Designed &amp;
          built in Sarajevo.
        </p>
      </div>
    </footer>
  );
}

export default GoodBye;
